import React from 'react';
import { AppSkinProps } from '../../../types/decisions';
import CriteriaSetting from './CriteriaSetting';
import './CriteriaSettings.scss';

interface CriteriaSettingsProps {
    criteriaFields: AppSkinProps['criteriaData']['fields'];
    fieldInitialValues: AppSkinProps['fieldInitialValues'];
    onTradeoffValueChange: AppSkinProps['onTradeoffValueChange'];
    onSliderChange: AppSkinProps['onSliderChange'];
    handleClose?: () => void;
    openCriteriaSettings?: (id: string) => void;
}

const CriteriaSettings = ({
    criteriaFields,
    fieldInitialValues,
    onTradeoffValueChange,
    onSliderChange,
    handleClose,
    openCriteriaSettings,
}: CriteriaSettingsProps) => {
    return (
        <div className="criteria-settings-container">
            {criteriaFields.map((field, index) => {
                if (field.hide_field) {
                    return null;
                }

                return (
                    <CriteriaSetting
                        key={field.id}
                        field={field}
                        fieldInitialValues={fieldInitialValues}
                        onTradeoffValueChange={onTradeoffValueChange}
                        onSliderChange={onSliderChange}
                        handleModalClose={handleClose}
                        openCriteriaSettings={openCriteriaSettings}
                    />
                );
            })}
        </div>
    );
};

export default CriteriaSettings;